module.exports = __webpack_public_path__ + "img/icon_map_5_yj_c.fb90c611.png";